import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const fetchAvailableServiceTimesDone = (payload) => ({
  type: TYPES.FETCH_AVAILABLE_SERVICE_TIMES_DONE,
  payload,
});

export const fetchAvailableServiceTimes = (id, servicePreferencesParams) => dispatch => {
  let servicePreferences =null;
  if (localStorage.getItem('theme') === 'Rize' || localStorage.getItem('theme') === 'Formwerks'){
    servicePreferences='Monday:Mornings'
  }else{servicePreferences=servicePreferencesParams}
  return client.fetchAvailableServiceTimes(id, servicePreferences)
  .then(
    response => {
      if(response.ok || response.status === 200){
        response.json().then(
          responsejson => {
            dispatch(fetchAvailableServiceTimesDone(responsejson))
          })
      }else{
        toast.error(' 🚫 Not able to fetch service time availability!',{autoClose:12000,position:'top-center' })
      }
    }
  ).catch( error => toast.error( ' 🚫 Something went wrong when fetching service time availability. Please try again ! ',{autoClose:12000,position:'top-center'}))
}

export const fetchPropertyDeveloperAvailableTimes = (id, servicePreferences) => dispatch => {
  return client.fetchPropertyDeveloperAvailableTimes(id, servicePreferences)
  .then(
    response => {
      if(response.ok || response.status === 200){
        response.json().then(
          responsejson => {
            dispatch(fetchAvailableServiceTimesDone(responsejson))
          })
      }else{
        toast.error(' 🚫 Not able to fetch service time availability!',{autoClose:12000,position:'top-center' })
      }
    }
  ).catch( error => toast.error( ' 🚫 Something went wrong when fetching service time availability. Please try again ! ',{autoClose:12000,position:'top-center'}))
}

export const clearAvailableServiceTimes = () => ({
  type:TYPES.CLEAR_AVAILABLE_SERVICE_TIMES
 })
